// extracted by mini-css-extract-plugin
module.exports = {"content":"AuthorizeToLogin_content__29fLO","sendOtp":"AuthorizeToLogin_sendOtp__2zTD1"};